const defaultImg = "//res-fengche.souche.com/20180816/png/2876f46a30e768284a7d5ca94be80bda.png";

const media = [
  {
    img: "https://assets-dfc.souche.com/2070413222058352640.png",
    title: "大搜车正式登陆纳斯达克，13年打造中国二手车AI应用基础设施",
    date: "2026/06/26",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/jKklSKJ4E7-YkTA4pbnIYg",
    id: "2026-06-26",
  },
  {
    img: "https://assets-dfc.souche.com/2053709137192116224.jpeg",
    title: "大搜车入选浙江&杭州独角兽企业",
    date: "2026/04/24",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/SJ3045dBR1g_dCbZYNL3BA",
    id: "2026-04-24",
  },
  {
    img: "https://assets-dfc.souche.com/2053710387991478272.webp?x-oss-process=image/format,jpg/interlace,1",
    title: "268V与电驴时代达成战略合作，共筑新能源二手车检测新生态",
    date: "2026/04/13",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/_J8Iqgn27MjLxWctnj4alg",
    id: "2026-04-13",
  },
  {
    img: "https://assets-dfc.souche.com/2053711322838925312.webp?x-oss-process=image/format,jpg/interlace,1",
    title: "268V获中国质量检验协会3·15主题活动“全国行业质量领先企业”等荣誉",
    date: "2026/03/24",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/c7nsa9MVwNljOWoV0p3a1A",
    id: "2026-03-24",
  },
  {
    img: "https://assets-dfc.souche.com/1992857587175198720.webp?x-oss-process=image/format,jpg/interlace,1",
    title: "大搜车荣获2025中国汽车流通行业“数智化转型先锋企业”称号",
    date: "2025/11/11",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/0EeTh17KMmDgvnb4amdOxg",
    id: "2025-11-11",
  },
  {
    img: "https://res-fengche.souche.com/bolt/_frPO2lMhXcjhMEuCUrAZ/12.jpeg",
    title: "大搜车入选“2025中国汽车行业可持续发展实践案例”",
    date: "2025/07/14",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/uAmgGLACE4FG8ViY5bLukQ",
    id: "2025-07-14",
  },
  {
    img: "https://assets-dfc.souche.com/1992858661155618816.webp?x-oss-process=image/format,jpg/interlace,1",
    title: "268V质量检验稳定合格！再度入选全国“质量月”诚信倡议企业",
    date: "2025/10/10",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/6cVPScPatxokDvGjq4_FLA",
    id: "2025-10-10",
  },
  {
    img: "https://res-fengche.souche.com/bolt/trY3cD8lpfsyM3IQpjHsT/1.webp?x-oss-process=image/format,jpg/interlace,1",
    title: "中检测评与大搜车签署战略合作协议，共建二手车第三方检测新格局",
    date: "2025/07/04",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/Tdq25v6bMsx_VJ9FzSHvZQ",
    id: "2025-07-04",
  },
  {
    img: "https://res-fengche.souche.com/bolt/oXNQKnTLxvirnfkBFGia2/1.jpeg",
    title: "大搜车上榜第九届万物生长大会“浙江省独角兽企业”",
    date: "2025/04/25",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/Gxmb78gaKjN4MpXFNuhUiA",
    id: "2025-04-25",
  },
  {
    img: "https://res-fengche.souche.com/bolt/9zXoVqJ831h1TIfIP6Zfl/5.webp?x-oss-process=image/format,jpg/interlace,1",
    title: "中检测评与大搜车达成战略合作，举办全国首次二手车实车碰撞测试公演活动",
    date: "2025/03/27",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/NuQ8HIrwWnLBfJlAETOTew",
    id: "2025-03-27",
  },
  {
    img: "https://res-fengche.souche.com/bolt/Hdy9Crmx-eNSK9O0fxgRA/1.webp?x-oss-process=image/format,jpg/interlace,1",
    title: "268V获得中国质量检验协会评选的“全国行业质量领先企业”等荣誉",
    date: "2025/03/17",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/GjSP6pzorlVnsYRVPZCUfw",
    id: "2025-03-17",
  },
  {
    img: "https://res-fengche.souche.com/bolt/cmBbSte8uubRpPQDu2j1H/640.webp?x-oss-process=image/format,jpg/interlace,1",
    title: "“大风车”入选2024年度互联网助力经济社会数字化转型特色案例",
    date: "2024/11/11",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/GJvzS7papcXOAr4kQB1B8g",
    id: "2024-11-11",
  },
  {
    img: "https://res-fengche.souche.com/bolt/QaC-aIcyBvbSSfhvm56gL/image.jpeg",
    title: "车易拍、268V入选2024年全国“质量月”质量诚信倡议企业",
    date: "2024/10/08",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/RfNkSD2frOK4mqf1djy3HQ",
    id: "2024-10-08",
  },
  {
    img: "https://res-fengche.souche.com/bolt/E985yDIW0rsa75oGF2Dlj/640%20(3).png",
    title: "中国汽研二手车检测和估值数字化解决方案正式发布，大搜车参与共同开发",
    date: "2024/09/24",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/L3rUU3IY5EottxgGyF6QSw",
    id: "2024-09-24",
  },
  {
    img: "https://res-fengche.souche.com/bolt/kKsYJfwEI4reYGzNc9IGb/640%20(20).webp?x-oss-process=image/format,jpg/interlace,1",
    title: "大搜车入选“2024全球独角兽企业500强榜单”",
    date: "2024/07/01",
    from: "大搜车",
    scale: "contain",
    fromUrl: "https://mp.weixin.qq.com/s/EqBsdr3XI0mfpzDxQfhQHg",
    id: "2024-07-01",
  },
  {
    img: "https://res-fengche.souche.com/bolt/akLqF-Whjc0crRhvSRo1A/640%20(19).webp?x-oss-process=image/format,jpg/interlace,1",
    title: "助力车企营销破圈，一鹿新车斩获品牌营销界虎啸奖、金梧奖多项荣誉",
    date: "2024/06/25",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/pGT7OOIpFqDju9MmwligsQ",
    id: "2024-06-25",
  },
  {
    img: "https://res-fengche.souche.com/bolt/XcSgIB9FoXdpvLTZ51pll/3.png",
    title: "大搜车入选2024杭州独角兽企业榜单",
    date: "2024/04/26",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/6jA2yV_IBtKP1otgfPyTZA",
    id: "2024-04-26",
    scale: "contain",
  },
  {
    img: "https://res-fengche.souche.com/bolt/g08TaMSivJOZ_qGvPIns6/2.png",
    title: "一鹿新车斩获2024金轩奖！创意短视频玩转汽车营销",
    date: "2024/04/25",
    from: "网易新闻 ",
    fromUrl: "https://www.163.com/news/article/J0KS6I6R00019UD6.html",
    id: "2024-04-25",
    scale: "contain",
  },
  {
    img: "https://res-fengche.souche.com/bolt/0l8vzZGvzqAebz2nWzzIL/1.png",
    title: "给出新车营销破局方案，一鹿新车斩获2024金璨奖“年度新零售营销奖”",
    date: "2024/04/01",
    from: "中国网",
    fromUrl: "https://t.m.china.com.cn/convert/c_vzWT9dwz.html",
    id: "2024-04-01",
  },
  {
    img: "https://res-fengche.souche.com/bolt/SsxHthPUNOvOzB1dprvX7/640%20(12).webp?x-oss-process=image/format,jpg/interlace,1",
    title: "助力汽车高效出海！运车管家荣获汽车出口平台创始会员",
    date: "2024/03/29",
    from: "运车管家",
    fromUrl: "https://mp.weixin.qq.com/s/qlXSSRLs2fnSQD-SmZ4fbw",
    id: "2024-03-29",
  },
  {
    img: "https://res-fengche.souche.com/bolt/1znMW07INTVSmjG53AL8W/%E5%9B%BE%E7%89%873.png",
    title: "喜报！运车管家荣获高新技术企业4A评级",
    date: "2024/03/21",
    from: "运车管家",
    fromUrl: "https://mp.weixin.qq.com/s/iEwOyogYj-aUTObuVjEkkw",
    id: "2024-03-21",
    scale: "contain",
  },
  {
    img: "https://res-fengche.souche.com/bolt/DLHpFpo9IMEnytPL-dMiS/640%20(9).webp?x-oss-process=image/format,jpg/interlace,1",
    title: "全国智能新能源汽车后市场行业产教融合共同体在钓鱼台国宾馆成立",
    date: "2024/03/18",
    from: "268V二手车检测",
    fromUrl: "https://mp.weixin.qq.com/s/Uf1vqbW0HEyGG-yC7hgbkw",
    id: "2024-03-18",
  },
  {
    img: "https://res-fengche.souche.com/bolt/itXFyBOufu9k_8muojJGw/640%20(6).webp?x-oss-process=image/format,jpg/interlace,1",
    title: "268V荣获中国质量检验协会“全国产品和服务质量诚信示范企业”称号",
    date: "2024/02/18",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/v6BeE0bUhq9dob8V4AWo4A",
    id: "2024-02-18",
  },
  {
    img: "https://res-fengche.souche.com/bolt/t2sXK2L25ZbuKtqPOeuIW/640.webp?x-oss-process=image/format,jpg/interlace,1",
    title: "中国汽研新能源汽车检测方案落地268V杭州门店，为消费者购买二手新能源汽车保驾护航",
    date: "2024/02/05",
    from: "268V二手车检测",
    fromUrl: "https://mp.weixin.qq.com/s/UzY4tFtWZgOsryg7vhZFsQ",
    id: "2024-02-05",
  },
  {
    img: "https://res-fengche.souche.com/bolt/FZrle-NhnOvvvod7f0Ip2/65a4ee6ae4b00c772112cb69_m%20(1).png",
    title: "一鹿新车斩获2023TBI杰出品牌创新奖，打造汽车直播营销新范式",
    date: "2024/01/15",
    from: "中国日报",
    fromUrl: "https://cn.chinadaily.com.cn/a/202401/15/WS65a4f167a310af3247ffc082.html",
    id: "2024-01-15",
  },
  {
    img: "https://res-fengche.souche.com/bolt/kz6LhhmsOobXZoCLnXnGn/%E5%9B%BE%E7%89%872.png",
    title: "大搜车入选全国工商联“数字化赋能十强企业”榜单",
    date: "2023/12/15",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/hk-14f8C_L_7YCVwZT8BeA",
    id: "2023-12-15",
    scale: "contain",
  },
  {
    img: "https://res-fengche.souche.com/bolt/hghVjXzyz4o13xAuv9_c5/%E4%B8%8B%E8%BD%BD.jpeg",
    title: "斩获2023数字化营销金牛奖，大搜车一鹿新车领跑汽车直播赛道",
    date: "2023/12/08",
    from: "大众新闻",
    fromUrl: "https://www.163.com/tech/article/ILF24J0E00099BK0.html",
    id: "2023-12-08",
  },
  {
    img: "https://res-fengche.souche.com/bolt/7wMvRpg5oDRVGxS-iYcfQ/640%20(3).jpeg",
    title: "数字化赋能汽车产业升级，大搜车荣获2023产业互联网“千峰奖”",
    date: "2023/12/04",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/PJIa_ogiLgGwIkIhc9nkiQ",
    id: "2023-12-04",
    scale: "contain",
  },
  {
    img: "https://res-fengche.souche.com/bolt/5wbigurtQ_utbG6BYixWx/640%20(5).jpeg",
    title: "大搜车、268V荣获2023中国汽车流通行业“行业创新”及“诚信经营”奖",
    date: "2023/11/22",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/RAd1SGHuPVE9ngUtU80ymA",
    id: "2023-11-22",
    scale: "contain",
  },
  {
    img: "https://res-fengche.souche.com/bolt/FwlbEZwRVUJ4EH3As2yGq/640%20(1).jpeg",
    title: "268V荣获中国质量检验协会“全国质量诚信标杆企业”称号",
    date: "2023/09/25",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/NdkhUOhpSPly53jiZ2COpQ",
    id: "2023-09-25",
    scale: "contain",
  },
  {
    img: "https://res-fengche.souche.com/bolt/RfxO-2pYv_LiGG10CGrDA/640.jpeg",
    title: "大搜车上榜2023全球独角兽企业500强榜单",
    date: "2023/09/04",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/W3Zne_GFaeI6dQbzP2Gv5w",
    id: "2023-09-04",
    scale: "contain",
  },
  {
    img: "//res-fengche.souche.com/bolt/SA5gJEGu2y7js8HFwWEIr/905cbd31-5e3b-42fa-b7df-be9e6d7ccfdf.jpg",
    title: "大搜车与浙江大学管理学院合作课程“汽车企业数字化经营管理”正式落地",
    date: "2023/07/06",
    from: "中国汽车报网",
    fromUrl: "http://www.cnautonews.com/houshichang/2023/07/06/detail_20230706358045.html",
    id: "2023-07-06",
  },
  {
    img: "//res-fengche.souche.com/f2e/8691fabd78f7bfd8fbc0b242c81650f7.jpeg",
    title: "268V荣获人工智能大会“AI+车辆检测质量保障体系建设”最具创新实践奖",
    date: "2023/04/18",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/re0MiV4WTuD1J56lmAZnOQ",
    id: "2023-04-18",
    scale: "contain",
  },
  {
    img: "//res-fengche.souche.com/f2e/69cc1457ee2c1031ff437f3f39a655c1.png",
    title: "大搜车入选2023年“杭州独角兽企业榜单”",
    date: "2023/04/11",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/71N59cmTm3nhfRDtoqWJJA",
    id: "2023-04-11",
  },
  {
    img: "//res-fengche.souche.com/f2e/c0796c8731eafd96259979a01c03d330.jpeg",
    title: "大搜车成为中国信通院“云优化能力提升计划”成员单位",
    date: "2023/04/07",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/uPxR9fiAOKc4ZOOVZYC6Qg",
    id: "2023-04-07",
  },
  {
    img: "//res-fengche.souche.com/f2e/48ed58a59e610de2f267b670dbf0e706.jpeg",
    title: "大搜车成为中国信通院“卓信大数据计划”成员单位",
    date: "2023/03/03",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/62gpbJ_Amn_IfKHD39LhRA",
    id: "2023-03-03",
  },
  {
    img: "//res-fengche.souche.com/f2e/733b9cbe772e073e91bacc2383285311.jpg",
    title: "大搜车接入百度文心一言，加速汽车经销商场景服务智能化升级",
    date: "2023/02/24",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/qq6AEsQ8R3jme59MZgHoGw",
    id: "2023-02-24",
  },
  {
    img: "//res-fengche.souche.com/f2e/e3b35f747b941b3f730d653b9bfeb0b4.JPG",
    title: "大搜车与平安银行签署战略合作协议，按下汽车金融数字化场景服务“快捷键”",
    date: "2023/02/09",
    from: "中国网科技",
    fromUrl: "http://tech.china.com.cn/hydt/20230209/394006.shtml",
    id: "2023-02-09",
    scale: "cover",
  },
  {
    img: "//res-fengche.souche.com/f2e/28eaa7d09b177120dbc0b48247702584.png",
    title: "大搜车荣获2022中国汽车流通行业综合实力及数字化转型两项大奖",
    date: "2023/01/12",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/UZnDLatO28Wda7DoyXgrxw",
    id: "2023-01-12",
    scale: "contain",
  },
  {
    img: "//res-fengche.souche.com/f2e/5ea7b64a4f0ffc524490f7f8527d7bca.png",
    title: "大搜车上榜2022全球独角兽企业500强榜单",
    date: "2023/01/03",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/G8gOFpNhW4TTVFu_O8qPGQ",
    id: "2023-01-03",
    scale: "contain",
  },
  {
    img: "//res-fengche.souche.com/f2e/24d868b1385a8ce06a3f49da9ea49566.png",
    title: "大搜车入选2022中国互联网大会特色案例",
    date: "2022/12/16",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/kQge1UsmJIrMCzt_Apkw3Q",
    id: "2022-12-16",
    scale: "contain",
  },
  {
    img: "//res-fengche.souche.com/f2e/0875b22441d6a632bf9cf9e9874fdfe5.jpeg",
    title: "车易拍、268V在全国质量月活动中荣获“全国质量诚信标杆企业”称号",
    date: "2022/09/26",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/pMvhmqIr8ApWfweFimKc4g",
    id: "2022-09-26",
  },
  {
    img: "//res-fengche.souche.com/f2e/bdd30fe8d7b28b9ab3f8137a4aabeeca.JPG",
    title: "大搜车上榜胡润研究院发布的《2022年中全球独角兽榜》",
    date: "2022/08/31",
    from: "大搜车",
    fromUrl: "https://mp.weixin.qq.com/s/c8C6NrLU6gsz2taFqk4MFg",
    id: "2022-08-31",
  },
  // {
  //   img: "//res-fengche.souche.com/f2e/71a4f193aae6ef2db6f52f44edf1df3a.jpg",
  //   title: "大搜车二手车工厂店全国首家体验中心落地山东潍坊",
  //   date: "2022/07/11",
  //   from: "中国财经网",
  //   fromUrl: "http://finance.china.com.cn/roll/20220711/5844912.shtml",
  //   id: "2022-07-11",
  // },
  {
    img: "//res-fengche.souche.com/f2e/d0bf45293891219fec115de045940aa4.jpeg",
    title: "大搜车入选2022年杭州独角兽企业榜单！",
    date: "2022/06/27",
    from: "大搜车",
    fromUrl:
      "https://mp.weixin.qq.com/s?__biz=MjM5NDM2NzUyMg==&mid=2649734793&idx=1&sn=2a231fd8e7345e207714cee9719e1888&chksm=be93cfc489e446d233bb26bb5c23bf5d00287ef6229cd74df6220c66443d539801644e03ff54&token=722025896&lang=zh_CN#rd",
    id: "2022-06-27-1",
  },
  {
    img: "//res-fengche.souche.com/f2e/400f1ac948b9316962e6d2a84dc3203f.jpg",
    title: "用数字化管好每一台车，运车管家自营仓突破80个！",
    date: "2022/05/17",
    from: "运车管家",
    fromUrl: "https://mp.weixin.qq.com/s/2uV-Q5R4JWBTi4CKI76IoQ",
    id: "2022-05-17-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/f356f67bb489cddb7768a33df33d1567.png",
    title: "从数字化管理工具到二手车商智能生意伙伴 “大风车”全面升级",
    date: "2022/05/17",
    from: "中国汽车流通协会",
    fromUrl: "https://mp.weixin.qq.com/s/ZVpOJMDjLcnj39zMH6j7NQ",
    id: "2022-05-17",
  },
  {
    img: "//res-fengche.souche.com/f2e/b485613c61e5f3884fd2fd9b5359fe0d.png",
    title: "汽车厂商联手第三方拍卖平台，加速布局二手车置换业务",
    date: "2022/04/28",
    from: "中国经营网",
    fromUrl: "http://www.cb.com.cn/index/show/gszx/cv/cv135267281338",
    id: "2022-04-28-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/3839c3d7095c28375fac39e7175aa119.jpg",
    title: "第三方“体检报告”让二手车消费更有保障",
    date: "2022/04/28",
    from: "人民日报",
    fromUrl: "https://wap.peopleapp.com/article/rmh28297940/rmh28297940",
    id: "2022-04-28",
  },
  {
    img: "//res-fengche.souche.com/f2e/a80244f2ccf925153e9313dc3e0afaa9.jpeg",
    title: "中国质量检验协会联手268V，让二手车消费者更放心",
    date: "2022/04/07",
    from: "爱卡汽车",
    fromUrl: "https://newcar.xcar.com.cn/nanchang/202204/news_203455263_1.html",
    id: "2022-04-07",
  },
  {
    img: "//res-fengche.souche.com/f2e/59bf7fe3dcb8d4d2b1d0b1d35a0fbf33.jpg",
    title: "268V荣获“全国产品和服务质量诚信示范企业”称号",
    date: "2022/03/28",
    from: "中国网",
    fromUrl: "http://anjian.china.com.cn/html/csaq/csdt/20220328/46040.html",
    id: "2022-03-28-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/3a16dd65ac0b544d34e6680aa892c4d2.png",
    title: "二手车检测机构268V通过ISO9001质量管理体系认证",
    date: "2022/03/28",
    from: "中国经营网",
    fromUrl: "http://www.cb.com.cn//index/show/gszx/cv/cv135265651335",
    id: "2022-03-28",
  },
  {
    img: "//res-fengche.souche.com/f2e/dbaa0d146f1373d2ad262690aceb47a6.jpg",
    title: "车易拍再获“全国产品和服务质量诚信示范企业”荣誉称号",
    date: "2022/03/16",
    from: "财讯网",
    fromUrl: "https://tech.china.com/article/20220315/032022_1029663.html",
    id: "2022-03-16-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/407cc26b48274cb71defba43a5bcfa49.png",
    title: "汽车新零售服务升级，大搜车5家汽车换购店进驻云南中国石油加油站",
    date: "2022/03/16",
    from: "中国经营网",
    fromUrl: "http://www.cb.com.cn//index/show/gszx/cv/cv135264891339",
    id: "2022-03-16",
  },
  {
    img: "//res-fengche.souche.com/f2e/43536ba6a770c6105d4f06475579a686.webp",
    title: "牛！大搜车被评定为浙江省级高新技术企业研究开发中心！",
    date: "2022/02/25",
    from: "杭州新闻",
    fromUrl: "https://h5.newaircloud.com/detailArticle/18400842_32655_hzxw.html",
    id: "2022-02-25",
  },
  {
    img: "//res-fengche.souche.com/f2e/d174c6dca4b57a7501f77e78b71ff8cb.png",
    title: "大搜车签约嘉远汽车 数字化直销新能源汽车再下一城",
    date: "2022/02/14",
    from: "新浪汽车",
    fromUrl: "http://k.sina.com.cn/article_2506770970_956a4a1a001013dea.html",
    id: "2022-02-14",
  },
  {
    img: "//res-fengche.souche.com/f2e/adfc8f4c2ea683458720532573b95a27.jpeg",
    title: "汽车产业互联网平台大搜车入选2021高质量发展企业",
    date: "2022/01/19",
    from: "AI财经社",
    fromUrl: "https://baijiahao.baidu.com/s?id=1722373487202459377",
    id: "2022-01-19",
  },
  {
    img: "//res-fengche.souche.com/f2e/7fbf9f85b31e0679c2ac127df95a8b5f.png",
    title: "运车管家全国首推“无忧运车”服务，让您轿车托运全程无忧",
    date: "2022/01/06",
    from: "i黑马网",
    fromUrl: "https://www.iheima.com/article-330277.html",
    id: "2022-01-06",
  },
  {
    img: "//res-fengche.souche.com/f2e/cce83d8765f098404ef528050ac553ec.jpeg",
    title: "大搜车获评2021年度十佳汽车新零售企业",
    date: "2022/01/04",
    from: "财经头条",
    fromUrl: "https://cj.sina.com.cn/articles/view/3206746194/bf23105202701cybz",
    id: "2022-01-04",
  },
  {
    img: "//res-fengche.souche.com/f2e/3bba54ad2ee05f53387889975bc12134.png",
    title: "新车支持到家交付！极氪携手运车管家开创“极氪到家”交付新模式",
    date: "2021/12/23",
    from: "中国网",
    fromUrl: "http://business.china.com.cn/2021-12/23/content_41830708.html",
    id: "2021-12-23",
  },
  {
    img: "//res-fengche.souche.com/f2e/3aabdc6a4b9fd7c77d5af2b4559414fb.jpeg",
    title: "大搜车获颁2021年度创新产业互联网公司",
    date: "2021/12/17",
    from: "凤凰财经",
    fromUrl: "https://finance.ifeng.com/c/8C2hbAS3vjo",
    id: "2021-12-17",
  },
  {
    img: "//res-fengche.souche.com/f2e/f3528ebb2f851f3da2b3d6f0e0524501.jpeg",
    title: "大搜车获选2021年度汽车产业互联网平台",
    date: "2021/12/14",
    from: "中国网",
    fromUrl: "http://anjian.china.com.cn/html/csaq/csdt/20211214/41690.html",
    id: "2021-12-14",
  },
  {
    img: "//res-fengche.souche.com/f2e/5e7dca7132a85a1022442a84c1e49965.jpeg",
    title: "大搜车与山东国惠合资10亿元成立汽车融资租赁公司",
    date: "2021/12/10",
    from: "金融界",
    fromUrl: "http://biz.jrj.com.cn/2021/12/10222233996414.shtml",
    id: "2021-12-10",
  },
  {
    img: "//res-fengche.souche.com/bolt/SCblJ0NRLO-rzpYjWvBaT/%E4%B8%8B%E8%BD%BD.jpeg",
    title: "车易拍荣获2021中国汽车流通行业诚信经营奖",
    date: "2021/12/03",
    from: "网易新闻",
    fromUrl: "https://www.163.com/news/article/GQI75VTJ00019UD6.html",
    id: "2021-12-03-2",
  },
  {
    img: "//res-fengche.souche.com/bolt/BV6MrBG1sRk28DS3J_Doe/c6bdf4f9.jpeg",
    title: "大搜车获中国汽车流通行业数字化转型奖",
    date: "2021/12/03",
    from: "爱卡汽车网",
    fromUrl: "http://newcar.xcar.com.cn/nanchang/202112/news_203451335_1.html",
    id: "2021-12-03",
  },
  {
    img: "//res-fengche.souche.com/f2e/106fc6facdb58afaa02c764d4ff01f03.jpeg",
    title: "运车管家全国首推“便捷运车”服务：运车无差价，直连承运人！",
    date: "2021/12/01",
    from: "人民资讯",
    fromUrl: "https://baijiahao.baidu.com/s?id=1717921530384581175",
    id: "2021-12-01",
  },
  {
    img: "//res-fengche.souche.com/bolt/lRPlbEMa6HUBaVSeDTkFr/6ee1fbde-d69b-4524-8ea4-199001b5e182.jpeg",
    title: "大搜车与国银租赁签署战略合作协议 纵深推进汽车产业生态合作",
    date: "2021/11/26",
    from: "证券日报网",
    fromUrl: "http://m.zqrb.cn/gscy/qiyexinxi/2021-12-01/A1638358656103.html",
    id: "2021-11-26",
  },
  {
    img: "//res-fengche.souche.com/bolt/kp6b-GZlwh66WnqCWB6dd/2021-11-25-1.jpeg",
    title: "268V推出二手车ECU智能检测解决方案",
    date: "2021/11/25",
    from: "汽车之家",
    fromUrl: "https://www.autohome.com.cn/news/202111/100343267.html",
    id: "2021-11-25",
  },
  {
    img: defaultImg,
    title: "大搜车摘得猎车·2021年度最佳汽车产业互联网平台",
    date: "2021/11/18",
    from: "腾讯新闻",
    fromUrl: "https://view.inews.qq.com/a/20211125A063H500",
    id: "2021-11-18",
  },
  {
    img: defaultImg,
    title: "重庆市二手车商会与268V战略签约",
    date: "2021/10/31",
    from: "重庆频道",
    fromUrl: "http://cq.news.cn/2021-11/03/c_1128026732.htm",
    id: "2021-10-31",
  },
  {
    img: "//res-fengche.souche.com/bolt/dMdfV_sclchDY6w-vhUz7/1635231779410.jpeg",
    title: "推动车辆检测数字化 268V获AI+车辆检测科技最具创新应用奖",
    date: "2021/10/26",
    from: "经济观察网",
    fromUrl: "http://www.eeo.com.cn/2021/1026/508868.shtml",
    id: "2021-10-26",
  },
  {
    img: "//res-fengche.souche.com/f2e/2c1e668e7efb96ca3e04276d414a7158.jpeg",
    title: "助力汽车直销模式，运车管家首推第三方车辆交付服务业务",
    date: "2021/09/26",
    from: " 汽车托运 ",
    fromUrl: "https://www.sohu.com/a/491611094_121059358",
    id: "2021-09-26-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/e498175f4761e1ea11a04f49607ad852.jpeg",
    title: "大搜车入选2021全球独角兽企业500强榜单",
    date: "2021/09/26",
    from: " 消费日报社 ",
    fromUrl: "https://new.qq.com/omn/20210926/20210926A088ED00.html",
    id: "2021-09-26",
  },
  {
    img: "//res-fengche.souche.com/f2e/b60c56e617806abe43a0d833a66458ab.jpeg",
    title: "2021年世界互联网大会：大搜车首次发布汽车交易引擎",
    date: "2021/09/25",
    from: " 环球网 ",
    fromUrl: "https://tech.huanqiu.com/article/44ujjbdPctE",
    id: "2021-09-25",
  },
  {
    img: "//res-fengche.souche.com/f2e/f3a4d577f8760dde6fb25b2ecb838626.jpeg",
    title: "大搜车旗下车易拍参与编制的《乘用车鉴定评估技术规范》即将实施",
    date: "2021/09/23",
    from: " 搜狐商讯 ",
    fromUrl: "https://www.sohu.com/a/491506433_120181749",
    id: "2021-09-23",
  },
  {
    img: "//res-fengche.souche.com/f2e/e8b5acfe560c628a75851df80bf90c62.jpeg",
    title: "大搜车旗下一鹿有车获 “年度优秀数字营销服务商”奖",
    date: "2021/09/18",
    from: " 汽车E时讯 ",
    fromUrl: "https://page.om.qq.com/page/OIZi5J9UBEOUj9x3p0b-0jIQ0",
    id: "2021-09-18",
  },
  {
    img: "//res-fengche.souche.com/f2e/58dea74408327432a863a332c35812ce.jpeg",
    title: "大搜车联合中石油推出汽车换购店 撬动万亿汽车换购市场",
    date: "2021/09/09",
    from: " 中国经济网 ",
    fromUrl: "https://wap.peopleapp.com/article/rmh23334327/rmh23334327",
    id: "2021-09-09",
  },
  {
    img: "//res-fengche.souche.com/f2e/d1682985d4a825b20112ea58da3a9a45.jpeg",
    title: "大搜车荣获2021中国汽车行业PaaS优秀解决方案奖",
    date: "2021/08/09",
    from: " 北晚新视觉网 ",
    fromUrl: "https://baijiahao.baidu.com/s?id=1707595636164799323",
    id: "2021-08-09-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/f8a7146edce4d165e25d7c005bb229b9.png",
    title: "268V亮相中国二手车大会，正式成为首批签约“行”认证授权机构",
    date: "2021/07/21",
    from: " 媒体新视角 ",
    fromUrl: "https://new.qq.com/omn/20210721/20210721A05ZJ800.html",
    id: "2021-07-21",
  },
  {
    img: "//res-fengche.souche.com/f2e/a3f8ac952ff30c2d2baeb3862228c291.png",
    title: "车易拍蔡旭：经销商迎来进入二手车市场的决定性时点",
    date: "2021/07/13",
    from: " 财报网 ",
    fromUrl: "https://finance.ifeng.com/c/87orii6StTE",
    id: "2021-07-13",
  },
  {
    img: "//res-fengche.souche.com/f2e/087b172b913f468540d42ddde68aae68.jpeg",
    title: "大搜车许竹潇：优化入口、做大出口，赋能经销商加快库存周转",
    date: "2021/07/12",
    from: " 车易拍 ",
    fromUrl: "https://new.qq.com/omn/20210712/20210712A050O400.html",
    id: "2021-07-12-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/d0aefc62b1397de6dec1d564665732c9.jpeg",
    title: "4位企业负责人的“汽车生活”： 让未来更好出行",
    date: "2021/06/23",
    from: " 每日经济新闻 ",
    fromUrl: "https://m.nbd.com.cn/articles/2021-06-22/1803744.html",
    id: "2021-06-23",
    imgStyle: {
      backgroundPosition: "left",
    },
  },
  {
    img: "//res-fengche.souche.com/f2e/fd535b18273707657ce06799084a1dfa.jpeg",
    title: "大搜车宣布与中石化达成合作 合作汽车销售服务",
    date: "2021/05/26",
    from: " 凤凰网科技 ",
    fromUrl: "https://tech.ifeng.com/c/86YXdMN90bG",
    id: "2021-05-26",
  },
  {
    img: "//res-fengche.souche.com/f2e/2b8bddf707030bb19bd0057de6967cb9.jpeg",
    title: "第五届万物生长大会举行 大搜车连续4年入选杭州独角兽企业榜单",
    date: "2021/04/28",
    from: " 杭州网 ",
    fromUrl: "https://baijiahao.baidu.com/s?id=1698276481412028358&wfr=spider&for=pc",
    id: "2021-04-28-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/298375dad2fd07572c18677ccc0c9993.png",
    title: "数据驱动汽车产业发展，大搜车荣获2021最具投资价值品牌奖",
    date: "2021/04/27",
    from: " 新浪 ",
    fromUrl: "http://finance.sina.com.cn/tech/2021-04-28/doc-ikmxzfmk9503961.shtml",
    id: "2021-04-27-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/4248d89d031892b43bb4c4282f115501.webp",
    title: "一月提成6万！西湖边来了两位小伙，他们的卖车经历太励志",
    date: "2021/04/23",
    from: " 钱江晚报 ",
    fromUrl: "https://mp.weixin.qq.com/s/4vRMdrxD-daf6vUHEsJOqQ",
    id: "2021-04-23",
  },
  {
    img: "//res-fengche.souche.com/f2e/15b176a4c5e29421196cb29fc0bdda89.png",
    title: "二手车拍卖成交率达80％，车易拍携手申湘集团举办春季拍卖会",
    date: "2021/04/17",
    from: " 腾讯网 ",
    fromUrl: "https://xw.qq.com/amphtml/20210417A042IC00",
    id: "2021-04-17-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/b4bc8bdfa8ddfa055d58b5a6cb00d523.jpeg",
    title: "中国数字阅读大会在杭州开幕 大搜车24车管家与咪咕数媒跨界服务全国2亿车主",
    date: "2021/04/16",
    from: " 品玩 ",
    fromUrl: "https://www.pingwest.com/w/237900",
    id: "2021-04-16-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/241805b85b18374879362947b19804af.jpeg",
    title: "大搜车入选产业升级年度十佳赋能者，以数据赋能汽车产业升级",
    date: "2021/03/25",
    from: " 雷锋网 ",
    fromUrl: "https://www.leiphone.com/category/digitalindustry/8H0sFr8tLVdfQiiA.html",
    id: "2021-03-25-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/2a35d0377b35a352a8221c9d9fdf3773.jpg",
    title: "姚军红：以用户为中心重构汽车消费产业链",
    date: "2021/03/11",
    from: " 新京报 ",
    fromUrl: "http://epaper.bjnews.com.cn/html/2021-03/11/content_798996.htm?div=02",
    id: "2021-03-11",
  },
  {
    img: "//res-fengche.souche.com/f2e/759fd147d974331c4c9f701dae81e750.png",
    title: "大搜车智云联合百度指数发布2020年度新能源乘用车白皮书",
    date: "2021/03/10",
    from: " 新京报 ",
    fromUrl: "https://baijiahao.baidu.com/s?id=1693821035838181618&wfr=spider&for=pc",
    id: "2021-03-10-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/c9eca14a761f3807682bbb45cb87aa34.webp",
    title: "中国企业家：《暖心！十余位企业家一起做了这件事……》",
    date: "2021/02/06",
    from: " 中国企业家 ",
    fromUrl: "https://mp.weixin.qq.com/s/BVJIxlOd0eKsg3rgsruK7A",
    id: "2021-02-06",
  },
  {
    img: "//res-fengche.souche.com/f2e/f04b4cf1195bb8b55831d2abdfde64db.png",
    title: "大搜车旗下一鹿有车荣获2020年度创新营销奖",
    date: "2021/01/26",
    from: " 消费日报 ",
    fromUrl: "http://www.xfrb.com.cn/article/shgc-msjj/17122993040487.html",
    id: "2021-01-26",
  },
  {
    img: "//res-fengche.souche.com/f2e/a05a617bd468d4115d88fa7d2ea81565.jpeg",
    title: "大搜车姚军红：汽车产业数字文明的推手",
    date: "2021/01/15",
    from: " 36Kr ",
    fromUrl: "https://36kr.com/p/1110661808679175",
    id: "2021-01-15",
  },
  {
    img: "//res-fengche.souche.com/f2e/4925f38f3abf19bb996202b61c082ca9.png",
    title: "大搜车旗下一鹿有车发布2020年度百强汽贸榜",
    date: "2021/01/13",
    from: " 中国经济新闻网 ",
    fromUrl: "http://www.cet.com.cn/wzsy/cyzx/2755872.shtml",
    id: "2021-01-13",
  },
  {
    img: "//res-fengche.souche.com/f2e/65c83879cc0e829ebcc2063d6e3f08b7.png",
    title: "企业帮扶暖人心 潍坊聋哑兄弟收到大搜车2021年度医疗教育资助",
    date: "2021/01/07",
    from: " 新华网 ",
    fromUrl: "http://www.xinhuanet.com/tech/2021-01/07/c_1126956712.htm",
    id: "2021-01-07",
  },
  {
    img: "//res-fengche.souche.com/f2e/0e68c2701aec6243633692d6557dabb0.jpg",
    title: "《人民政协报》：紧密团结，继续前进！——业界人士点赞习近平主席新年贺词",
    date: "2021/01/05",
    from: " 人民政协报 ",
    fromUrl: "http://rmzxb.bzzb.tv/shareart_3520238_5.html",
    id: "2021-01-05",
  },
  {
    img: "//res-fengche.souche.com/f2e/d42fe41f0ee0d1ed4c6cd258727a84cf.jpg",
    title: "2020中国车商高峰论坛成功举行 大搜车获评“十佳新零售平台”",
    date: "2020/12/29",
    from: " 中国财经 ",
    fromUrl: "http://finance.china.com.cn/roll/20201229/5464711.shtml",
    id: "2020-12-29-3",
  },
  {
    img: "//res-fengche.souche.com/f2e/2bf34662ca0f0a13414a6f5d12817857.png",
    title: "大搜车姚军红：数字时代业务转型的底层逻辑",
    date: "2020/12/11",
    from: " 中国企业家 ",
    fromUrl: "http://www.iceo.com.cn/renwu2013/2020/1211/308181.shtml",
    id: "2020-12-11",
  },
  {
    img: "//res-fengche.souche.com/f2e/301f8261c4e182c103d86829a17e09a1.jpg",
    title: "大搜车入选全球独角兽企业 500 强",
    date: "2020/12/03",
    from: " 中新经纬 ",
    fromUrl: "http://www.jwview.com/jingwei/12-03/365543.shtml",
    id: "2020-12-03",
  },
  {
    img: "//res-fengche.souche.com/f2e/3b0e058c74fd93e8670ce2153f217a84.jpg",
    title: "大搜车入选商务部数字商务企业名单",
    date: "2020/12/01",
    from: " 环球网 ",
    fromUrl: "https://tech.huanqiu.com/article/40vL8V601ZB",
    id: "2020-12-01-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/85e69afcc8a32c7f1c990abb2901fb22.jpg",
    title: "大搜车入选中国新经济企业 500 强",
    date: "2020/11/30",
    from: " 每日经济新闻 ",
    fromUrl: "http://www.nbd.com.cn/articles/2020-11-30/1559887.html",
    id: "2020-11-30",
  },
  {
    img: "//res-fengche.souche.com/f2e/17bce16743faeb4f328245fa24987956.jpg",
    title: "大搜车姚军红荣获“2020浙商年度创新人物”",
    date: "2020/11/26",
    from: " 每日商报 ",
    fromUrl: "https://mdaily.hangzhou.com.cn/mrsb/2020/11/26/article_detail_3_20201126A078.html",
    id: "2020-11-26",
  },
  {
    img: "//res-fengche.souche.com/f2e/ad001554578ae2c18d5bc0e660c585f2.jpg",
    title: "汽车产业转型提速 大搜车CEO姚军红：数字化的核心是提升行业整体效率",
    date: "2020/11/25",
    from: " 每日经济新闻 ",
    fromUrl: "https://m.nbd.com.cn/articles/2020-11-25/1556081.html",
    id: "2020-11-25",
  },
  {
    img: "//res-fengche.souche.com/f2e/71b2a9a5dd5753c3be368dc0607418b7.png",
    title: "大搜车24车如何赋能汽车经销商提升线上销售力？",
    date: "2020/11/24",
    from: " 腾讯网 ",
    fromUrl: "https://new.qq.com/rain/a/20201123a0d6rm00",
    id: "2020-11-24",
  },
  {
    img: "//res-fengche.souche.com/f2e/74897548a1c4061afeee3a4f3766ff86.jpg",
    title: "大搜车亮相2020“互联网之光”博览会 大数据定制新车吸引关注",
    date: "2020/11/23",
    from: " 光明网 ",
    fromUrl: "https://it.gmw.cn/2020-11/23/content_34391685.htm",
    id: "2020-11-23",
  },
  {
    img: "//res-fengche.souche.com/f2e/8e89d374de31d652af0c458bf4e07ab9.jpeg",
    title: "车易拍受邀参加中国汽车流通行业年会，获颁“卓越贡献企业”奖",
    date: "2020/11/20",
    from: " 网易新闻 ",
    fromUrl: "https://news.163.com/20/1120/13/FRSNTCDI00019OH3.html",
    id: "2020-11-20",
  },
  {
    img: "//res-fengche.souche.com/f2e/464a9e71edd97959f307f2493f198a27.png",
    title: "大搜车荣获中国汽车流通行业社会公益榜样奖",
    date: "2020/11/18",
    from: " 中国日报 ",
    fromUrl: "http://ex.chinadaily.com.cn/exchange/partners/82/rss/channel/cn/columns/sz8srm/stories/WS5fb5e44da3101e7ce97306db.html",
    id: "2020-11-18-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/f386460eaf4bb7ea904a5f9ffc1465ef.jpg",
    title: "大搜车荣获“中国汽车流通行业互联网创新企业奖”",
    date: "2020/11/18",
    from: " 财经网 ",
    fromUrl: "http://industry.caijing.com.cn/20201118/4715600.shtml",
    id: "2020-11-18",
  },
  {
    img: "//res-fengche.souche.com/f2e/da34adbd1a7725f4eba2422c0a9adfde.png",
    title: "大搜车滴滴出行等获选 2020 中国新经济独角兽 TOP 100",
    date: "2020/11/05",
    from: " 北京商报 ",
    fromUrl: "https://www.bbtnews.com.cn/2020/1105/375178.shtml",
    id: "2020-11-05",
  },
  {
    img: "//res-fengche.souche.com/f2e/02510c86c334711fe7e8f467e35ffe69.png",
    title: "大搜车与广汽传祺达成新零售战略合作 GS3 POWER 定制版上市",
    date: "2020/10/30",
    from: " 搜狐新闻 ",
    fromUrl: "https://www.sohu.com/a/428423358_120089985",
    id: "2020-10-30-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/8001b63ee2a2c059aebc0017b149f557.jpeg",
    title: "车易拍与广汽商贸战略合作 共建“广汽二手车新零售平台”",
    date: "2020/10/27",
    from: " 搜狐新闻 ",
    fromUrl: "https://www.sohu.com/a/428955728_817091",
    id: "2020-10-27-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/53cf64b221cf6633cfbbb0ce8ac19c48",
    title: "大搜车推出新品牌“大搜车wowcar”",
    date: "2020/10/12",
    from: " 千龙网产经中心 ",
    fromUrl: "https://baijiahao.baidu.com/s?id=1680310462094671786",
    id: "2020-10-12",
  },
  {
    img: "//res-fengche.souche.com/f2e/6da99b36bb9f842f29d43c9387fe001b.jpg",
    title: "大搜车姚军红：创造未来商业要在底层建立逻辑，在高处打开格局",
    date: "2020/09/16",
    from: " 每经网 ",
    fromUrl: "http://www.nbd.com.cn/articles/2020-09-16/1506245.html",
    id: "2020-09-16",
  },
  {
    img: "//res-fengche.souche.com/f2e/4c8779d1ac19b7aa77b3995e2a19be79.jpg",
    title: "大搜车与阿里体育战略合作",
    date: "2020/08/19",
    from: " 浙江在线 ",
    fromUrl: "http://zjtyol.zjol.com.cn/tyjsb/202008/t20200819_12233958.shtml",
    id: "2020-08-19",
  },
  {
    img: "//res-fengche.souche.com/f2e/0178773683e25c087ade1047b3558bff.png",
    title: "大搜车旗下运车管家获网络货运平台牌照",
    date: "2020/08/07",
    from: " 北京商报 ",
    fromUrl: "http://www.bbtnews.com.cn/2020/0807/364116.shtml",
    id: "2020-08-07-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/e776a5f5a72d4ce71ad526561c17ee9c.png",
    title: "第四届万物生长大会在杭举行 阿里云大搜车网易严选入选2020杭州独角兽榜单",
    date: "2020/06/30",
    from: " 中国新闻网 ",
    fromUrl: "https://caijing.chinadaily.com.cn/a/202006/30/WS5efb0453a310a859d09d5144.html",
    id: "2020-06-30",
  },
  {
    img: "//res-fengche.souche.com/f2e/a9e1670dc20c2b0386447c9c5f8c974c.jpg",
    title: "奇瑞汽车与大搜车达成新零售战略合作",
    date: "2020/06/16",
    from: " 中国新闻网 ",
    fromUrl: "http://www.chinanews.com/business/2020/06-16/9214054.shtml",
    id: "2020-06-16-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/8fdd338a761cd101ca6d5682df775995.jpeg",
    title: "大搜车宣布并购云漾科技 闭环全场景数字化能力",
    date: "2020/06/15",
    from: " 腾讯新闻 ",
    fromUrl: "https://new.qq.com/omn/20200615/20200615A08RDI00.html",
    id: "2020-06-15-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/4d4b168181b51a5be42d2cdbb14cd03f.png",
    title: "大搜车姚军红：商业的本质是建立“连接”，通过“协议”实现“资产交换”",
    date: "2020/06/10",
    from: " 众为利他学院",
    fromUrl: "https://mp.weixin.qq.com/s/IMzhjaUcS7TgJ5FMA16stQ",
    id: "2020-06-10",
  },
  {
    img: "//res-fengche.souche.com/f2e/200388fe4ad231cdf641d43323fde111.jpg",
    title: "大搜车与吉利联手推数字化直销 会动4S店的蛋糕吗?",
    date: "2020/5/19",
    from: " 网易汽车",
    fromUrl: "https://auto.163.com/20/0519/12/FD05Q0B7000884ML.html",
    id: "2020-05-19-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/d66527b3146186f2172fd37c381c83b3.webp",
    title: "对话大搜车姚军红：多数人追求业务结果，我要建一个可持续的组织",
    date: "2020/03/30",
    from: " 捕手志",
    fromUrl: "https://mp.weixin.qq.com/s/ZsS2zCWh5oivhxJaGRh-eg",
    id: "2020-03-30",
  },
  {
    img: "//res-fengche.souche.com/f2e/04f142d6371e5a0cc765e5679b85e682.png",
    title: "姚军红2万字访谈实录，企业补上数字化一课",
    date: "2020/03/06",
    from: "汽车商业评论",
    fromUrl: "https://mp.weixin.qq.com/s/ZI_tQ50EqOmmvi3tUpLw6w",
    id: "2020-03-06",
  },
  {
    img: "//res-fengche.souche.com/f2e/64cc27bd516980ec4a34ed128acdaeef.jpeg",
    title: "姚军红：最好的抗“疫”方式是深度挖掘“用户金矿”",
    date: "2020/03/03",
    from: "腾讯网",
    fromUrl: "https://new.qq.com/omn/AUT20200/AUT2020030302328904",
    id: "2020-03-03",
  },
  {
    img: "//res-fengche.souche.com/f2e/4911bc8768d749ac2899682bfd06a35b.jpg",
    title: "弹个车平台负责人魏南衡：我们是这样“弹”动小镇青年",
    date: "2019/12/29",
    from: "一财网",
    fromUrl: "https://baijiahao.baidu.com/s?id=1654261278812004483&wfr=spider&for=pc",
    id: "2019-12-29",
  },
  {
    img: "//res-fengche.souche.com/f2e/dd39a4d0b513114cef8c0fe736d17cd1.jpg",
    title: "大搜车姚军红：一层一层解决信任问题",
    date: "2019/12/27",
    from: "南方周末",
    fromUrl: "http://www.infzm.com/contents/173269",
    id: "2019-12-27",
  },
  {
    img: "//res-fengche.souche.com/f2e/bc0506a063e399264eb60ac8310e5aec.jpeg",
    title: "2亿小镇青年成买车主力 弹个车覆盖七成区县开启新蓝海",
    date: "2019/12/25",
    from: "央广网",
    fromUrl: "http://news.cnr.cn/native/lmgd/20191225/t20191225_524912138.shtml",
    id: "2019-12-25",
  },
  {
    img: "//res-fengche.souche.com/f2e/6d147121c8a176b7bab89827dfbf750f.png",
    title: "大搜车姚军红：我们做的是汽车流通领域的连接和协议",
    date: "2019/12/12",
    from: "财经天下",
    fromUrl: "https://mp.weixin.qq.com/s/tUJ_N1sq8ENpJa-WG56P6w",
    id: "2019-12-12",
  },
  {
    img: "//res-fengche.souche.com/f2e/d66527b3146186f2172fd37c381c83b3.webp",
    title: "弹个车三年谋局：渠道下沉，模式上扬",
    date: "2019/11/21",
    from: "中国新闻周刊",
    fromUrl: "https://mp.weixin.qq.com/s/71dt2ajshuE1Ig9m6I9pGw",
    id: "2019-11-21",
  },
  {
    img: "//res-fengche.souche.com/f2e/9af33d266d13f8e9be634b96432183b4.jpg",
    title: "上午11时35分：天猫双11首位客户弹个车成功提车",
    date: "2019/11/11",
    from: "中国网",
    fromUrl: "http://zjnews.china.com.cn/yuanchuan/2019-11-11/197548.html",
    id: "2019-11-11",
  },
  {
    img: "//res-fengche.souche.com/f2e/1bde977bd744edf96e06eeccc0a1c09a.webp",
    title: "头号玩家姚军红：每一次创业都是一条命",
    date: "2019/08/30",
    from: "商界",
    fromUrl: "https://mp.weixin.qq.com/s/9B_1_fCAwE6DqiRLr0H8nQ",
    id: "2019-08-30",
  },
  {
    img: "//res-fengche.souche.com/f2e/cfe884ea8c9375e05eaa5b87362c2767.webp",
    title: "发动群众搞定小镇青年，大搜车能在汽车行业做成准阿里模式吗？",
    date: "2018/08/16",
    from: "财经故事会",
    fromUrl: "https://mp.weixin.qq.com/s/aeinwlyILGwa2CDJnrhnLw",
    id: "fa-dong",
    // getContent: () => import('./news/fa-dong.html')
  },
  {
    img: "//res-fengche.souche.com/20180816/png/ac28ab270b0b1bc58e7a34b41b939ca2.png",
    title: "万亿级的汽车流通市场里隐藏着多少中国式机会",
    date: "2018/08/16",
    from: "界面",
    fromUrl: "http://m.jiemian.com/article/2118462.html",
    id: "wan-yi",
    // getContent: () => import('./news/wan-yi.html')
  },
  {
    img: "//res-fengche.souche.com/20180816/png/a7bb4446b245b5ee4fa4566b9a3a060b.png",
    title: "携手阿里巴巴 大搜车实力布局汽车新零售生态圈",
    date: "2018/08/16",
    from: "商讯早知道",
    fromUrl: "https://www.toutiao.com/i6548650695136903694/",
    id: "xie-shou",
    // getContent: () => import('./news/xie-shou.html')
  },
  {
    img: "//res-fengche.souche.com/20180816/png/2876f46a30e768284a7d5ca94be80bda.png",
    title: "制造汽车「最强大脑」",
    date: "2018/08/16",
    from: "人物",
    fromUrl: "https://mp.weixin.qq.com/s/6aVy5Y1Jux2EWntEmS1XfQ",
    id: "zhi-zhao",
    // getContent: () => import('./news/zhi-zhao.html')
  },
  {
    img: "//res-fengche.souche.com/20180816/png/48a7c85e3c093fb3e7b9ccce30799306.png",
    title: "半年超3000家社区店抢占新渠道，弹个车是疯狂还是有所依仗？",
    date: "2018/08/16",
    from: "AC汽车",
    fromUrl: "https://mp.weixin.qq.com/s/nsMYmgl5XYUHcTwhypG_uw",
    id: "ban-nian",
    // getContent: () => import('./news/ban-nian.html')
  },
  {
    img: "//res-fengche.souche.com/20180816/png/74290a4429ba95d06146ccddcef98b9e.png",
    title: "别克这几天凭借一个大动作，大面积搞定小镇青年",
    date: "2018/08/16",
    from: "产经头条",
    fromUrl: "https://mp.weixin.qq.com/s/FlxOBIGep9Jq1BGY1FFEhw",
    id: "bie-ke",
    // getContent: () => import('./news/bie-ke.html')
  },
  {
    img: "//res-fengche.souche.com/20180816/png/13600d412782f71ba39e37c85aae9c14.png",
    title: "大搜车的新零售战争",
    date: "2018/08/16",
    from: "i黑马",
    fromUrl: "https://mp.weixin.qq.com/s/RLQFSWapLFNwCIUh6qVSnw",
    id: "da-sou-che-de-xin",
    // getContent: () => import('./news/da-sou-che-de-xin.html')
  },
];

const official = [
  {
    img: "//res-fengche.souche.com/f2e/bdce98b1ec6133cb3e33ec50a3eeae30.png",
    title: "大搜车荣获2021中国汽车行业PaaS优秀解决方案奖",
    date: "2021/08/09",
    id: "2021-08-09",
  },
  {
    img: "//res-fengche.souche.com/f2e/f853c724ee7ec244813b6e9a69b99284.webp",
    title: "268V成为中国汽车流通协会首批指定“行”认证授权机构",
    date: "2021/07/12",
    id: "2021-07-12",
  },
  {
    img: "//res-fengche.souche.com/f2e/6be8d07b01d135e7b26d49c7c17250e4.webp",
    title: "第六届SaaS大会举行 大搜车获评年度最具影响力数字化服务商",
    date: "2021/06/30",
    id: "2021-06-30",
  },
  {
    img: "//res-fengche.souche.com/f2e/1150be2b3fc0f48bd9c9b9d431c79f24.webp",
    title: "大搜车亮相2021中国汽车论坛 助力汽车产业高质量发展",
    date: "2021/06/18",
    id: "2021-06-18",
  },
  {
    img: "//res-fengche.souche.com/f2e/18ee7a0bc7b931c9789eb49bc6ffd0bf.webp",
    title: "中旅旅行和运车管家达成战略合作",
    date: "2021/06/07",
    id: "2021-06-07",
  },
  {
    img: "//res-fengche.souche.com/f2e/c89342ae05c7f16f4df4ad5860c77f01.png",
    title: "大搜车荣获“浙商经济年度创新企业” 以数据驱动汽车产业升级",
    date: "2021/05/27",
    id: "2021-05-27",
  },
  {
    img: "//res-fengche.souche.com/f2e/7518abbc92aba6428c2355e9693675c9.webp",
    title: "第五届万物生长大会举行 大搜车连续4年入选杭州独角兽企业榜单",
    date: "2021/04/28",
    id: "2021-04-28-1",
  },
  {
    img: "//res-fengche.souche.com/f2e/d7b6987f2a3e8e82a26f552c5dddbef6.webp",
    title: "大搜车荣获2021最具投资价值品牌奖，以数据赋能汽车产业升级",
    date: "2021/04/27",
    id: "2021-04-27-1",
  },
  {
    img: "//res-fengche.souche.com/f2e/188d5735e6aa2fa4de471cdfd11bbe4f.webp",
    title: "二手车拍卖成交率达80%，车易拍携手申湘集团举办春季拍卖会",
    date: "2021/04/17",
    id: "2021-04-17-1",
  },
  {
    img: "//res-fengche.souche.com/f2e/7ff43970e12244845ce153af58b62646.webp",
    title: "大搜车24车管家与咪咕数媒跨界服务全国2亿车主",
    date: "2021/04/16",
    id: "2021-04-16-1",
  },
  {
    img: "//res-fengche.souche.com/f2e/be47feddc9a6a752cbde4347e64cc8a4.png",
    title: "车易拍持续推进数字化赋能，合众集团二手车利润实现三年翻倍",
    date: "2021/04/08",
    id: "2021-04-08",
  },
  {
    img: "//res-fengche.souche.com/f2e/b1597ed421f45a9a3bdc9793756be724.webp",
    title: "大搜车入选产业升级年度十佳赋能者，以数据赋能汽车产业升级",
    date: "2021/03/25",
    id: "2021-03-25-1",
  },
  {
    img: "//res-fengche.souche.com/f2e/d0d0c6b669c7976183c4b90b3689ad68.webp",
    title: "大搜车智云&百度指数：宏光MINI成2020年新能源车最大“黑马”",
    date: "2021/03/10",
    id: "2021-03-10-1",
  },
  {
    img: "//res-fengche.souche.com/f2e/3d39fd19027aa070fa8cc3155fb41537.png",
    title: "大搜车荣获2020年度创新营销奖",
    date: "2021/01/25",
    id: "2021-01-25-1",
  },
  {
    img: "//res-fengche.souche.com/f2e/55f27c0f84d2eeb60878fab58c11129e.png",
    title: "大搜车荣获机器之心2020年度最具产业价值技术应用落地案例TOP 30",
    date: "2021/01/20",
    id: "2021-01-20",
  },
  {
    img: "//res-fengche.souche.com/f2e/1a3625f304d0b9f5001b0af0953a2048.png",
    title: "2020中国车商高峰论坛成功举行 大搜车获评“十佳新零售平台”",
    date: "2020/12/29",
    id: "2020-12-29-1",
  },
  {
    img: "//res-fengche.souche.com/f2e/9c87f5d604da1501db41cc8fa52483c2.png",
    title: "大搜车荣获2020“年度汽车数字文明推动者”称号",
    date: "2020/12/29",
    id: "2020-12-29-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/2ffe950b2c034327fb5251fc2ae43228.png",
    title: "大搜车获选中国组织能力标杆企业20强",
    date: "2020/12/21",
    id: "2020-12-21-1",
  },
  {
    img: "//res-fengche.souche.com/f2e/c93413ff975a55226eb59de6cc66246c.webp",
    title: "大搜车入选全球独角兽企业500强",
    date: "2020/12/02",
    id: "2020-12-02",
  },
  {
    img: "//res-fengche.souche.com/f2e/f7278714dde43a854021443d49bbd5ec.webp",
    title: "大搜车入选商务部数字商务企业名单",
    date: "2020/12/01",
    id: "2020-12-01",
  },
  {
    img: "//res-fengche.souche.com/f2e/d6a112ae17b3932787b011e210eab9e2.webp",
    title: "大搜车入选中国新经济企业500强",
    date: "2020/11/28",
    id: "2020-11-28",
  },
  {
    img: "//res-fengche.souche.com/f2e/cfdb9fbdf4842b008dc3c3c6bf4527a2.webp",
    title: "大搜车亮相2020“互联网之光”博览会 以用户为中心赋能汽车生态",
    date: "2020/11/22",
    id: "2020-11-22",
  },
  {
    img: "//res-fengche.souche.com/f2e/3a15a0aa82ceb741dd053b8e5d5dfd53.webp",
    title: "构建汽车产业数字生态 大搜车获颁互联网创新企业奖",
    date: "2020/11/17",
    id: "2020-11-17-2",
  },
  {
    img: "//res-fengche.souche.com/f2e/27e644639898497b496417714a3231f9.webp",
    title: "大搜车荣获中国汽车流通行业社会公益榜样奖",
    date: "2020/11/17",
    id: "2020-11-17",
  },
  {
    img: "//res-fengche.souche.com/f2e/f936aa7c314273d432a0c901c691fb39.png",
    title: "大搜车入选2020年度中国新经济独角兽 数字化赋能汽车产业",
    date: "2020/11/03",
    id: "2020-11-03",
  },
  {
    img: "//res-fengche.souche.com/f2e/30a09504d8c240005836d1e82dd30ffc.png",
    title: "大搜车与广汽传祺达成新零售战略合作 GS3 POWER 定制版上市",
    date: "2020/10/30",
    id: "2020-10-30",
  },
  {
    img: "//res-fengche.souche.com/f2e/2b8ad21f1dabcb6249e0d16d013d578e.webp",
    title: "运车管家荣获“汽车物流行业创新奖”",
    date: "2020/10/29",
    id: "2020-10-29",
  },
  {
    img: "//res-fengche.souche.com/f2e/71329b9618f2aec0864aff2775e1a83f.webp",
    title: "车易拍与广汽商贸战略合作 共建广汽二手车新零售平台",
    date: "2020/10/27",
    id: "2020-10-27",
  },
  {
    img: "//res-fengche.souche.com/f2e/b8c4231504f83d8d3bbfb6066a83fcf9.webp",
    title: "大搜车旗下车易拍荣获“质量月”六项大奖，推动二手车行业标准化、透明化发展",
    date: "2020/10/10",
    id: "2020-10-10",
  },
  {
    img: "//res-fengche.souche.com/f2e/0fe7a5cc79961ae9632a9f23f89f37d1.webp",
    title: "大搜车与阿里体育战略合作 开启人群定向场景新营销",
    date: "2020/08/18",
    id: "2020-08-18",
  },
  {
    img: "//res-fengche.souche.com/f2e/0178773683e25c087ade1047b3558bff.png",
    title: "北京市首张！大搜车旗下运车管家获网络货运平台牌照",
    date: "2020/08/07",
    id: "2020-08-07",
  },
  {
    img: "//res-fengche.souche.com/f2e/065c4d5f3d285d3e13b65af66122793a.png",
    title: "奇瑞汽车与大搜车达成新零售战略合作 2020款瑞虎7i全国直销",
    date: "2020/06/16",
    id: "2020-06-16",
  },
  {
    img: "//res-fengche.souche.com/f2e/bf124b9f69af5b8cb5fdf0c152fc946c.webp",
    title: "大搜车宣布并购云漾科技 闭环汽车流通领域全场景数字化能力",
    date: "2020/06/15",
    id: "2020-06-15",
  },
  {
    img: "//res-fengche.souche.com/f2e/379597410926c49dc9c15cc57dbe4933.png",
    title: "吉利汽车与大搜车达成新零售战略合作 首次实现真直销一口价",
    date: "2020/05/19",
    id: "2020-05-19",
  },
  {
    img: "//res-fengche.souche.com/f2e/664188d625576822b9a1a4a337daed91.jpeg",
    title: "大搜车荣登毕马威中国领先汽车科技企业50榜",
    date: "2020/04/21",
    id: "2020-04-21",
  },
  {
    img: "//res-fengche.souche.com/f2e/e4cb058e501da484a6421834ea2e426a.png",
    title: "4小时110单 大搜车播豹“线上直播车展”火了",
    date: "2020/02/27",
    id: "2020-02-27",
  },
  {
    img: "//res-fengche.souche.com/f2e/38b7e744694ec233885ec758dab6a02a.jpg",
    title: "大搜车推出汽车行业数据服务平台“大搜车智云”",
    date: "2020/02/24",
    id: "2020-02-24",
  },
  {
    img: "//res-fengche.souche.com/f2e/ff411af304f11424375045754759e0e8.png",
    title: "疫情时期，大搜车超级4S助力4000+汽车经销商在线运营",
    date: "2020/02/12",
    id: "2020-02-12",
  },
  {
    img: "//res-fengche.souche.com/f2e/ec6143f4d2b5594c8cd565a8802d85ee.jpeg",
    title: "疫情之下，大搜车联手全国车商开启直播卖车模式",
    date: "2020/02/11",
    id: "2020-02-11",
  },
  {
    img: "//res-fengche.souche.com/f2e/2a4785129534355e81099c8c3c7ee460.jpeg",
    title: "大搜车海外紧急采购23万只口罩 首批已捐赠武汉天门杭州",
    date: "2019/02/06",
    id: "2020-02-06",
  },
  {
    img: "//res-fengche.souche.com/6qa65u6hlyvl5edrhmcue311uovablpj",
    title: "大搜车获评“十大产业互联网独具投资价值企业”",
    date: "2019/09/27",
    id: "hulianwang_value",
  },
  {
    img: "//res-fengche.souche.com/8e7ghkwqm2jgouwkt7dgy4ej3vq7n1wx",
    title: "广东省二手车行业论坛开幕 大搜车家选推进行业标准化",
    date: "2019/08/28",
    id: "gaofeng_luntan",
  },
  {
    img: "//res-fengche.souche.com/u4psmh5bgnzb3dsfpu74ui2ipg8q3dn2",
    title: "大搜车牵手优酷4档重磅综艺 酷品牌内容定制引领汽车营销革命",
    date: "2019/08/02",
    id: "youku",
  },
  {
    img: "//res-fengche.souche.com/525ptfc976z2ul6ehsanpwbldmmo88ds",
    title: "大搜车家选宁波开城 优质车商联盟引领二手车新风向",
    date: "2019/07/28",
    id: "jiaxuan-ningbo",
  },

  {
    img: "//res-fengche.souche.com/zadwkuipgbrmx7bc8ojnyaoj3p3ea13u",
    title: "大搜车上榜“2019最具商业价值企业” 引领汽车产业数字化升级",
    date: "2019/07/25",
    id: "zuijushangyejiazhi",
  },
  {
    img: "//res-fengche.souche.com/07afgdffupivbhbk05knvdapiz93n44e",
    title: "大搜车上榜2019年中国大消费创新企业TOP50",
    date: "2019/07/24",
    id: "top50",
  },
  {
    img: "//res-fengche.souche.com/293xfr2lh4obvqi4oz7ct5r7yc786pkt",
    title: "大搜车获评中国二手车流通行业领军企业",
    date: "2019/07/18",
    id: "gaofengluntan",
  },
  {
    img: "//res-fengche.souche.com/n9h1a6rxzn73mqski4io92ov0n7fw18e",
    title: "全国二手车鉴定评估师技能大赛决赛 大搜车家选获“特别贡献”奖",
    date: "2019/07/17",
    id: "jiaxuanbei",
  },
  {
    img: "//res-fengche.souche.com/yb3t8zgpv4e8cfjw8kem7lrdg1kil2ww",
    title: "张一鸣王兴姚军红入选“WISE 2019中国商业创变者50人”",
    date: "2019/07/09",
    id: "chuangbianzhe",
  },
  {
    img: "//res-fengche.souche.com/uhfv8nbh9as4sp6aea0c57us272c66gt",
    title: "大搜车荣膺“2019年度最具成长性新兴企业”",
    date: "2019/07/08",
    id: "xinxingqiye",
  },
  {
    img: "//res-fengche.souche.com/3l9q6pzn5c1o8xcei6mvmd6dbikt5i39",
    title: "618弹个车逆市成交15673台车 以汽车新零售激发市场活力",
    date: "2019/06/19",
    id: "618",
  },
  {
    img: "//res-fengche.souche.com/s6xm8bobeomizcsij59o7l7e0ihzzu0q",
    title: "推动汽车产业数字文明，大搜车荣膺“2019数字经济创新企业100强”",
    date: "2019/06/18",
    id: "chuangxinqiye",
  },
  {
    img: "//res-fengche.souche.com/ducs3iyz6q2f0gv5zqezuv5xogrgxaj9",
    title: "大搜车与上海银行市南分行达成100亿元全面战略合作",
    date: "2019/06/10",
    id: "shanghaiyinhang",
  },
  {
    img: "//res-fengche.souche.com/4qtau3u18bn836s4y5jhszggpaim0p6z",
    title: "大搜车超级4S亮相中国汽车经销商大会，助力经销商数字化转型",
    date: "2019/06/06",
    id: "chaoji4s",
  },
  {
    img: "//res-fengche.souche.com/kp4b41rgqg6xii0hrdzpaalzoofqyo1j",
    title: "大搜车与中国银行达成战略合作 开设国内首家“在线汽车银行”",
    date: "2019/05/31",
    id: "zhongguoyinhang",
  },
  {
    img: "//res-fengche.souche.com/9pdl82zig18d36w8vatythmrkyv09myi",
    title: "大搜车2019年会火热举办 威马汽车现场送出超级大奖",
    date: "2019/05/17",
    id: "nianhui",
  },
  {
    img: "//res-fengche.souche.com/6eno1n7r75glsf95mwn6b4tlbhaexc2s",
    title: "大搜车与浦发银行达成100亿元全面战略合作，合力推进汽车新金融生态",
    date: "2019/05/16",
    id: "pufayinhang",
  },
  {
    img: "//res-fengche.souche.com/78enhuhq2nzcck94629wu05u76p3dkru",
    title: "大搜车10亿重金打造优质车商联盟“家选” 年内门店将超2000家",
    date: "2019/04/28",
    id: "da-souche-jia-xuan",
  },
  {
    img: "//res-fengche.souche.com/f2e/172684b81277718002693cea52afdee6.jpeg",
    title: "大搜车与中国建设银行浙江省分行达成50亿战略合作",
    date: "2019/04/23",
    id: "da-sou-che-yu-zhong-guo",
  },
  {
    img: "//res-fengche.souche.com/f2e/c9b16dc9d5bab7edaac8147b24e4cbbf.jpeg",
    title: "大搜车与淘宝二手车启动战略合作 携手10万车商共创新零售",
    date: "2019/04/04",
    id: "da-sou-che-yu-tao-bao",
  },
  {
    img: "//res-fengche.souche.com/f2e/3ec41f9d070663b82b35593665cfecb3.jpeg",
    title: "中石油携手大搜车迭代2.1万加油站+打造升级版人·车·生活驿站",
    date: "2019/04/04",
    id: "zhong-shi-you",
  },
  {
    img: "//res-fengche.souche.com/f2e/7ab87eb231bfa2deb3fde188bfb0166a.jpeg",
    title: "大搜车张立宇谈车市降速，汽车新零售是重振行业的一剂良药",
    date: "2018/12/21",
    id: "che-shi-jiang-su",
  },
  {
    img: "//res-fengche.souche.com/f2e/519930f4f51785718578a11e34f2fbe1.jpeg",
    title: "大搜车与中石油合作开展汽车全链路交易服务 携手迈入加油站3.0时代",
    date: "2018/12/21",
    id: "jia-you-zhan-3.0",
  },
  {
    img: "//res-fengche.souche.com/f2e/dd39a4d0b513114cef8c0fe736d17cd1.jpg@200h_2x.jpg",
    title: "大搜车姚军红获评2018中国年度产业创新者",
    date: "2018/12/21",
    id: "chan-ye-chuang-xin-zhe",
  },
  {
    img: "//res-fengche.souche.com/f2e/bb50502d0066f166a9e7057fd3ca03a6.jpeg",
    title: "央视走访大搜车 数字化成二手车行业升级关键",
    date: "2018/12/21",
    id: "shu-zi-hua-er-shou-che",
  },
  {
    img: "//res-fengche.souche.com/f2e/dd39a4d0b513114cef8c0fe736d17cd1.jpg@200h_2x.jpg",
    title: "大搜车姚军红获最佳创业领军人物奖 构建万亿级汽车产业互联网",
    date: "2018/12/21",
    id: "ling-jun-ren-wu-jiang",
  },
  {
    img: "//res-fengche.souche.com/f2e/230f4602f5179e3ce53e356758b3f6c3.png",
    title: "大搜车姚军红获“中国汽车金融20年之20人成就奖”",
    date: "2018/12/21",
    id: "cheng-jiu-jiang",
  },
  {
    img: "//res-fengche.souche.com/f2e/bae6ffd2f39ff05ae2f574b4292f359c.png",
    title: "张立宇：从零售四要素看大搜车的汽车新零售赋能之路",
    date: "2018/12/21",
    id: "ling-shou-si-yao-su",
  },
  {
    img: "//res-fengche.souche.com/f2e/6a3fa48035eee3ed08e4f6c8c16c4441.jpg",
    title: "弹个车发布双12战报， 不到半天破去年双12全天销量",
    date: "2018/12/21",
    id: "tan-ge-che-shuang-shi-er",
  },
  {
    img: "//res-fengche.souche.com/f2e/c23990556c965583d860e43356f20395.png",
    title: "推进汽车产业数字文明 大搜车获选年度数字化创新典范",
    date: "2018/12/21",
    id: "tui-jin-qi-che",
  },
  {
    img: "//res-fengche.souche.com/f2e/d9ec4f0f18165c86bdbed646ff5c828f.png",
    title: "以产业互联网掀起新零售变革 大搜车荣获2018年“十佳新零售”奖",
    date: "2018/12/21",
    id: "yi-hu-lian-wang",
  },
  {
    img: "//res-fengche.souche.com/f2e/5a053e04652679bbaf0573bee07c1e3d.png",
    title: "大搜车车牛与车易拍全面打通 推动二手车市场走向高效时代",
    date: "2018/12/21",
    id: "da-sou-che-che-niu",
  },
  {
    img: "//res-fengche.souche.com/f2e/3a8a8e992b7b1d8dcec7ebbf732b466c.webp",
    title: "姚军红获“2018中国汽车金融杰出推动者”奖 成中国汽车金融领袖人物",
    date: "2018/11/20",
    id: "yao-jun-hong",
  },
  {
    img: "//res-fengche.souche.com/f2e/93a08138e67640f4be004a1a8c5e0c36.jpeg",
    title: "大搜车CEO姚军红：双11再破纪录 未来坚持推动汽车产业数字文明",
    date: "2018/11/20",
    id: "da-sou-che-ceo-yao",
  },
  {
    img: "//res-fengche.souche.com/f2e/272ff4936b4c5077062fb7032152ef5e.jpeg",
    title: "弹个车开启极速购车时代 支付宝5分钟完成审核",
    date: "2018/10/31",
    id: "tan-ge",
  },
  {
    img: "//res-fengche.souche.com/f2e/29c9eb62108a4ba54cba06e946fd74b4.jpeg",
    title: "大搜车刘祚宏：汽车新零售的核心是解决浪费",
    date: "2018/10/31",
    id: "da-sou-che-liu-zuo",
  },
  {
    img: "//res-fengche.souche.com/f2e/ee84b296e13d1e8e42d51ce2018d7276.jpeg",
    title: "借助AliOS，大搜车开发智能硬件助力4S店",
    date: "2018/10/31",
    id: "jie-zhu",
  },
  {
    img: "//res-fengche.souche.com/f2e/089e740c1d62d307d491957d6bba76b1.jpeg",
    title: "从大搜车到瑞幸咖啡，最具投资价值商业模式出炉",
    date: "2018/10/31",
    id: "chong-da",
  },
  {
    img: "//res-fengche.souche.com/f2e/b918872b2aee445d431b1570db69f84d.webp",
    title: "大搜车与中石油昆仑好客达成战略合作，2万多家加油站开启汽车新零售",
    date: "2018/10/31",
    id: "da-sou-che-yu-zhong",
  },
  {
    img: "//res-fengche.souche.com/f2e/4219e5e2d8223a404c6e5cf66a884f36.JPG",
    title: "大搜车获新一轮融资5.78亿美金 不到1年累计融资超9亿美金",
    date: "2018/09/03",
    id: "da-sou-che-huo-xin",
    // getContent: () => import('./news/da-sou-che-huo-xin.html')
  },
  {
    img: "//res-fengche.souche.com/20180904/png/51e26bd1df7f616de52f5af7eebc2b1e.png",
    title: "金蝶汽车网络获大搜车A轮融资 携新零售平台赋能汽车市场",
    date: "2018/08/28",
    id: "jie-die",
    // getContent: () => import('./news/jie-die.html')
  },
  {
    img: "//res-fengche.souche.com/20180904/png/6e3c078b384e0e6593532defcbe64bdb.png",
    title: "汽车新零售赋能造车新势力：大搜车与电咖汽车达成战略合作",
    date: "2018/08/24",
    id: "qi-che",
    // getContent: () => import('./news/qi-che.html')
  },
  {
    img: "//res-fengche.souche.com/20180816/png/bb6fdf3b6f4cd9475db9f5806ee34076.png",
    title: "成交额超20亿！弹个车荣登天猫汽车618销量榜第一",
    date: "2018/08/16",
    id: "cheng-jiao",
    // getContent: () => import('./news/cheng-jiao.html')
  },
];

// 回收站
// const _recycle = [
//     {
//         img: '//res-fengche.souche.com/20180816/png/e8940710a461a741ddbc77157d12552d.png',
//         title: '大搜车的新零售战争',
//         date: '2018/08/16',
//         getContent: () => import('./news/da-sou-che-jia-shu.html')
//     }
// ]

const ALL = [...media, ...official];

media.forEach((ele) => {
  ele.type = "media";
});

official.forEach((ele) => {
  ele.type = "official";
  ele.from = "大搜车";
});

module.exports = {
  media,
  official,
  ALL,
};



// WEBPACK FOOTER //
// ./src/data/news.common.js